<template>
    <input v-if="selecting" type="checkbox" :checked="selected.includes(media.id)" @input="toggleMedia(media.id)" class="form-check-input me-3" style="width: 20px; height: 20px">
</template>

<script setup lang="ts">
import {inject} from "vue";
import {MediaItem} from "@/site/components/VideoElement.vue";

const { selected, toggleMedia } = inject('selected');

defineProps<{
    media: any,
    selecting: boolean,
}>();

</script>

<style scoped>

</style>
